export const featureGates = {
    ADULT_TEAM_PICKLEBALL: 'adult_team_pickleball',
    JUNIOR_TEAM_PICKLEBALL: 'junior_team_pickleball',
    GLOBAL_DROPDOWN_V2: 'global_dropdown_v2',
    WEB_NAV_V2: 'web_nav_v2',
    WEB_LEAGUES_LARGE_TOURNAMENT_SIZES: 'web_leagues_large_tournament_sizes',
};
